// Inline SVG icon set — the OTTracker logo, settings gear, and the 24×24
// 2px-stroke line icons ported from the design handoff.

// OTTracker clock-ring mark (the ring is the "O")
export function Logo({ size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden="true" style={{display:"block"}}>
      <circle cx="50" cy="50" r="36" stroke="currentColor" strokeWidth="13.5" />
      <rect x="45.5" y="23" width="9" height="29" rx="4.5" fill="currentColor" />
      <rect x="49" y="45.5" width="27" height="9" rx="4.5" fill="currentColor" transform="rotate(30 50 50)" />
      <circle cx="50" cy="50" r="5.6" fill="currentColor" />
    </svg>
  );
}

// Settings gear (Feather "settings" icon)
export function GearIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

const M_ICONS = {
  meal:    "M3 2v7a3 3 0 003 3v10M6 2v6M9 2v6M16 2c-1.5 1.5-2 4-2 7s.5 4 2 4v9",
  bed:     "M2 4v16M2 12h18a2 2 0 012 2v6M2 16h20M7 9h5a2 2 0 012 2v1H7z",
  car:     "M3 13l2-5.5A2 2 0 016.9 6h10.2a2 2 0 011.9 1.5L21 13M5 13h14a1 1 0 011 1v3a1 1 0 01-1 1h-1a1 1 0 01-1-1v-1H7v1a1 1 0 01-1 1H5a1 1 0 01-1-1v-3a1 1 0 011-1zM7 16h.01M17 16h.01",
  box:     "M3 7l9-4 9 4v10l-9 4-9-4V7zM3 7l9 4 9-4M12 11v10",
  tag:     "M20.6 13.4l-7.2 7.2a2 2 0 01-2.8 0l-7-7A2 2 0 013 12.2V5a2 2 0 012-2h7.2a2 2 0 011.4.6l7 7a2 2 0 010 2.8zM7.5 7.5h.01",
  receipt: "M5 3v18l2-1.2 2 1.2 2-1.2 2 1.2 2-1.2 2 1.2V3l-2 1.2L13 3l-2 1.2L9 3 7 4.2 5 3zM8 8h8M8 12h8M8 16h5",
  plus:    "M12 5v14M5 12h14",
  camera:  "M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2zM12 17a4 4 0 100-8 4 4 0 000 8z",
  upload:  "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 9l5-5 5 5M12 4v12",
  chevR:   "M9 6l6 6-6 6",
  chevL:   "M15 18l-6-6 6-6",
  list:    "M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01",
  history: "M3 3v5h5M3.05 13A9 9 0 106 5.3L3 8",
  x:       "M18 6L6 18M6 6l12 12",
  check:   "M20 6L9 17l-5-5",
  pencil:  "M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z",
};
export function MIcon({ n, s = 20 }) {
  const p = M_ICONS[n];
  if (!p) return null;
  return (
    <svg className="micon" width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {p.split("M").filter(Boolean).map((d, i) => <path key={i} d={"M" + d} />)}
    </svg>
  );
}
